import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/lib/ariadna/alert/alert.service';
import { LoadService } from './../../../services/application/load.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import {
    IAuthData,
    IDataForAuthCode,
    IPatientFind,
    ITokenAndPatientId,
} from 'src/app/interfaces/patient.interfaces';
import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { ICaptcha, ICaptchaData } from 'src/app/services/captcha/interfaces';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
import { DOCUMENT } from '@angular/common';
import { ContractService } from 'src/app/services/contract.service';
import { EsiaService } from 'src/app/services/esia.service';
import { Utils } from 'src/app/services/utils';
import { PatientService } from 'src/app/services/patient.service';
import { EmailInputModalComponent } from 'src/app/modals/email-input/email-input.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'app-auth-login',
    templateUrl: './login-form.component.html',
    styleUrls: ['../_auth-shared-styles.scss'],
    animations: [showOpacityAnimation],
    standalone: false,
})
export class LoginFormComponent implements OnInit, AfterViewInit, OnDestroy {
    public loginMode: number = 0; // 0 - пароль, 1 - номер
    public formBase: FormGroup = new FormGroup({
        login: new FormControl<string>('', [
            Validators.minLength(3),
            Validators.required,
        ]),
        password: new FormControl<string>('', [
            Validators.minLength(3),
            Validators.required,
        ]),
    });
    public formPhone: FormGroup = new FormGroup({
        phone: new FormControl<string>('', [
            Validators.required,
            Validators.minLength(11),
        ]),
        captcha: new FormControl<string>('', [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(6),
        ]),
    });
    @ViewChild('InputBlockLogin') public InputBlockLogin:
        ElementRef | undefined;
    @ViewChild('InputBlockPhone') public InputBlockPhone:
        ElementRef | undefined;
    public AccessReg: boolean = false; // Доступ к регистрации
    public AccessRecovery: boolean = false;
    public AuthType: string = 'base';
    public isMobile: boolean = false;
    public AuthFormTitle: string = ''; // название компонента авторизации
    public roleSystem: boolean = false; // Нужно ли получать информацию о доступных разделах пользователю при логине
    public dogPreviewRequired: boolean = false;
    public accessWithoutEmail: number = 1;
    public tmpToken: ITokenAndPatientId = { token: '', patientId: 0 };
    public esiaLink: string | null = null;
    private esiaState: string | null = null; // ГосУслуги-код (при переходе с ГосУслуг)
    public hidePassword: boolean = true;
    public captcha: ICaptcha = { id: '', svg: '' };
    public loading: boolean = false;
    public captchaLoad: boolean = false;
    public errorMessage: string = '';
    public constructor(
        private load: LoadService,
        private auth: AuthService,
        private patientService: PatientService,
        private cookieService: CookieConsentService,
        private alertService: AlertService,
        private captchaService: CaptchaService,
        private esia: EsiaService,
        private activateRoute: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private router: Router,
        private title: Title,
        private contractService: ContractService,
        private dialog: MatDialog,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.AccessReg =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REGISTRATION_ENABLED;
        this.AccessRecovery =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_RECOVERY_ENABLED;
        this.AuthType =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .AUTH_TYPE ?? 'base';
        this.AuthFormTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .AUTH_FORM_TEXT ?? 'Личный кабинет пациента';
        this.roleSystem =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_ROLES_SYSTEM;
        this.accessWithoutEmail =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REQUIRED_FILLED_EMAIL ?? 1;
        const tmpTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN.TITLE;

        if (tmpTitle) this.title.setTitle(tmpTitle);
        this.dogPreviewRequired =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REQUIRED_CONTRACT_PREVIEW;
    }
    public ngOnInit(): void {
        if (!this.load.configLoaded) {
            this.router.navigate(['/503']);
            return;
        }

        this.getCaptcha();

        if (this.AuthType.includes('sms') && !this.AuthType.includes('base'))
            this.loginMode = 1;
        else this.loginMode = 0;

        if (this.AuthType.includes('esia')) {
            lastValueFrom(this.esia.getInfo$())
                .then((result: string) => {
                    if (result) {
                        this.esiaLink = result;
                    }
                })
                .catch((error: any) => {
                    return null;
                });
        }
        // Проверка на state, переход с Госуслуг
        this.checkEsiaState();
        const tokenFromStorage = sessionStorage.getItem(
            'sessionTokenAuthAriadna',
        );

        if (!tokenFromStorage) {
            const token = Array(32)
                .fill('')
                .map(() =>
                    String.fromCharCode(
                        48 + Math.floor(Math.random() * (10 + 26 + 26)) - 10,
                    ),
                )
                .join('');
            sessionStorage.setItem('sessionTokenAuthAriadna', token);
        }
    }
    public ngAfterViewInit() {
        this.setFocus();
    }
    public ngOnDestroy(): void {}
    public changeLoginMode(mode: number) {
        this.loginMode = mode;
        this.cd.detectChanges(); // Принудительно обновляем DOM

        setTimeout(() => {
            this.setFocus(); // ставим фокус на первое поле ввода
        }, 0);
    }
    public async onSubmitBase() {
        this.loading = true;

        const data: IAuthData = {
            login: this.formBase.controls['login'].value,
            password: this.formBase.controls['password'].value,
        };
        try {
            this.cookieService.acceptAllCookies();

            const result = await this.auth.login$(data);

            if (result.patientId && result.token) {
                this.tmpToken = {
                    token: result.token,
                    patientId: result.patientId,
                };
                const patient = this.patientService.currentPatient;
                if (this.accessWithoutEmail === 2 && !patient?.email) {
                    this.errorMessage =
                        'Не указан почтовый адрес! Доступ запрещён';
                    throw new Error(
                        'Не указан почтовый адрес! Доступ запрещён',
                    );
                }
                if (this.accessWithoutEmail === 1 && !patient?.email) {
                    const dialogRef = this.dialog.open(
                        EmailInputModalComponent,
                        {
                            data: {
                                email: '',
                                message:
                                    'Для продолжения работы в личном кабинете укажите Ваш почтовый адрес',
                            },
                        },
                    );
                    const modalResult = await firstValueFrom(
                        dialogRef.afterClosed(),
                    );

                    if (modalResult && modalResult.newEmail) {
                        await this.auth.updateEmail(modalResult.newEmail);
                    } else {
                        this.auth.logout();
                        this.router.navigate(['auth/login']);
                        throw new Error(
                            'Без указанного почтового адреса доступ к сервису запрещён!',
                        );
                    }
                }

                await this.setAuthConfig();
                this.contractService.setToken(result.token);
                // заполняем куки при успешной авторизации
                if (!document.cookie.includes('cookieconsent_status')) {
                    this.cookieService.setCookie(
                        'cookieconsent_status',
                        'true',
                    );
                }
                // здесь тогда не направляем на документы, а отправляем в функцию проверки документов
                this.checkDocuments();
            }
        } catch (err: unknown) {
            this.errorMessage = Utils.getErrorMessage(err, 'Ошибка при входе');
            console.error('Ошибка на auth/login:', this.errorMessage);
            this.loading = false;
        }
    }

    public async onSubmitPhone() {
        this.loading = true;
        const captchaData: ICaptchaData = {
            id: this.captcha?.id,
            value: this.formPhone.controls['captcha'].value,
        };
        let data: Required<
            Pick<IPatientFind, 'captchaHash' | 'client' | 'phone'>
        > = {
            phone: this.formPhone.controls['phone'].value,
            client: {
                platform: 'WEB',
                otpDomain: this.document.location.hostname,
            },
            captchaHash: '',
        };
        try {
            const captchaVerifyResponse = await lastValueFrom(
                this.captchaService.verifyCaptcha(captchaData),
            );
            if (captchaVerifyResponse.captchaHash) {
                data = {
                    ...data,
                    captchaHash: captchaVerifyResponse.captchaHash,
                };
            }
        } catch (err: unknown) {
            this.errorMessage = Utils.getErrorMessage(
                err,
                'CAPTCHA устарела или код введён неверно',
            );
            this.refreshCaptcha();
            this.formPhone.get('captcha')?.reset();
            this.loading = false;
        }
        if (data.captchaHash) {
            try {
                this.cookieService.acceptAllCookies();
                const result = await lastValueFrom(
                    this.auth.sendAuthPhoneCode(data, 'LOGIN'),
                );
                const dataForcode: IDataForAuthCode = {
                    messageUuid: result.messageUuid,
                    delieveryChanel: 'SMS',
                    phoneOrMail: data.phone || '',
                };
                // после этого направляем на auth/code, в сервис отправляем messageUuid и delievery chanel
                this.auth.startAuthProcess(dataForcode, 'LOGIN');
            } catch (err: unknown) {
                this.errorMessage = Utils.getErrorMessage(
                    err,
                    'Ошибка при отправке кода',
                );
                console.error(this.errorMessage);
                this.refreshCaptcha();
                this.formPhone.get('captcha')?.reset();
            } finally {
                this.loading = false;
            }
        }
    }
    public async checkDocuments(): Promise<void> {
        // сделать запрос на получение документов - если пришли - засетать их в сервис документов. Если список пуст - на домашнюю. Если ошибка - на домашнюю.
        try {
            const docs = await lastValueFrom(
                this.contractService.getContractList(),
            );
            if (docs && docs.length > 0) {
                this.contractService.setDocuments(docs);
                await this.router.navigate(['/auth/sign-documents']);
            } else {
                this.cookieService.setCookie(
                    'pa-web_Patient_Local',
                    this.tmpToken.token,
                );
                await this.router.navigate(['/home']);
            }
        } catch (err: unknown) {
            this.errorMessage = Utils.getErrorMessage(
                err,
                'Ошибка при загрузке документов',
            );
            console.error(this.errorMessage);
            this.loading = false;
        }
    }
    public checkEsiaState() {
        if (
            this.activateRoute.snapshot.queryParams &&
            this.activateRoute.snapshot.queryParams.state
        ) {
            this.esiaState = this.activateRoute.snapshot.queryParams.state;
            this.loading = true;
            this.esia.getInfoState$(this.esiaState!).subscribe({
                next: (res: any) => {
                    this.loading = false;
                    this.tmpToken = {
                        token: res.token,
                        patientId: res.patientId,
                    };
                    this.cookieService.acceptAllCookies();
                    this.setAuthConfig();
                    if (!document.cookie.includes('cookieconsent_status')) {
                        this.cookieService.setCookie(
                            'cookieconsent_status',
                            'true',
                        );
                    }
                    this.cookieService.setCookie(
                        'pa-web_Patient_Local',
                        this.tmpToken.token,
                    );
                    this.checkDocuments();
                },
                error: (err: unknown) => {
                    this.alertService.error(Utils.getErrorMessage(err));
                    this.loading = false;
                },
            });
        } else {
            if (
                this.activateRoute.snapshot.queryParams &&
                this.activateRoute.snapshot.queryParams.ERR
            ) {
                console.error('Ошибка получения данных от ГосУслуг.');
            }
            this.esiaState = null;
            this.loading = false;
        }
    }
    public loginEsia() {
        this.loading = true;
        if (this.esiaLink) {
            window.location.href = this.esiaLink;
        }
    }
    public goToRegistration() {
        this.router.navigate(['auth/register']);
    }
    public goToRecovery() {
        this.router.navigate(['auth/recovery']);
    }
    public async getCaptcha() {
        this.captchaLoad = true;
        this.captcha = await this.captchaService.fetchCaptcha();
        this.captchaLoad = false;
    }
    public refreshCaptcha() {
        this.captcha = { id: '', svg: '' };
        this.formPhone.controls['captcha']?.setValue('');
        this.getCaptcha();
    }
    // TODEL: вот это потом удалить
    private async setAuthConfig(): Promise<void> {
        if (this.roleSystem && this.tmpToken?.patientId) {
            const res = await this.auth.getAccessConfig(
                this.tmpToken.patientId,
            );
            if (res.length <= 0) {
                res.push(
                    'lk_access_appointment',
                    'lk_access_patient_data',
                    'lk_access_see_services',
                );
            }
            this.load.setAccessUserConfig(res);
        }
    }
    public removeSpaces(event: any): void {
        const input = event.target;
        input.value = input.value.replace(/\s/g, '');
    }
    public setFocus() {
        if (this.InputBlockPhone) {
            this.InputBlockPhone.nativeElement.focus();
        }
        if (this.InputBlockLogin) {
            this.InputBlockLogin.nativeElement.focus();
        }
    }

    public focusNextInput(event: Event): void {
        event.preventDefault();

        const target = event.target as HTMLElement;
        const form = target.closest('form');

        if (!form) {
            return;
        }

        const inputs = Array.from(
            form.querySelectorAll<HTMLInputElement>(
                'input:not([disabled]):not([readonly])',
            ),
        );

        const currentIndex = inputs.indexOf(target as HTMLInputElement);
        const nextInput = inputs[currentIndex + 1];

        if (nextInput) {
            nextInput.focus();
            return;
        }

        const button = form.querySelector<HTMLButtonElement>(
            'button[type="submit"]:not([disabled])',
        );

        if (button) {
            button.click();
        }

        target.blur();
    }
}
// import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
// import {
//     FormControl,
//     FormGroup,
//     Validators,
//     UntypedFormBuilder,
// } from '@angular/forms';
// import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
// import { AuthService } from '../../../services/auth.service';
// import { IPatient, ITokenAndPatientId } from '../../../interfaces/patient';
// import { ActivatedRoute, Router } from '@angular/router';
// import { ConfigService } from '../../../services/application/config.service.';
// import { LoadService } from '../../../services/application/load.service';
// import { Title } from '@angular/platform-browser';
// import { EsiaService } from '../../../services/esia.service';
// import { CookieConsentService } from 'src/app/services/cookie-consent-service';
// import { lastValueFrom } from 'rxjs';
// import { AlertService } from 'src/lib/ariadna/alert';
// import { IAppConfig } from 'src/app/interfaces/response';

// @Component({
//     selector: 'app-auth',
//     templateUrl: './auth.component.html',
//     styleUrls: ['./auth.component.scss'],
//     animations: [showOpacityAnimation],
// })
// export class AuthComponent implements OnInit {
//     @Input() AccessReg: boolean = false;
//     animState = 'on';
//     loading = false; // Загрузка
//     hidePassword = true; // Показывать пароль
//     isRecovery = false; // Возможность восстанавления пароля
//     frm!: FormGroup;
//     getRolesConfig = false; // Нужно ли получать информацию о доступных разделах пользователю при логине
//     private authSettings?: IAppConfig['CLIENT_SETTINGS']['PAGES_SETTINGS']['LOGIN'];
//     public tmpToken: ITokenAndPatientId | null;
//     public tokens: string | null;
//     public dogPREVIEW_REQUIRED: boolean = false; // Обязательность предпросмотра
//     public error = '';
//     public showDoglist = false;
//     public captchaJpg = ''; // картинка дла КАПЧИ
//     //  public dogHoverId: number = 0;  // Наведенный договор, если нет то = 0
//     public patient: IPatient | null = null; // Авторизированный пациент
//     private paramEmit = 1; // 1- Регистрация, 3- по телефону
//     public Auth_type = ''; // Тип авторизации

//     /*
//         0 - Только по логину и  паролю из карты пациента
//         1 - Только по телефону (МНТК)
//         2 - Вход по логину и паролю с возможностью авторизации по телефону
//   */

//     private esia_state: string | null = null; // ГосУслуги-код (при переходе с ГосУслуг)
//     public esia_link: string | null = null; // доступность кнопки Авторизациии через ГосУслуги

//     get username() {
//         // @ts-ignore
//         return this.frm.get('username').value;
//     }

//     get password() {
//         // @ts-ignore
//         return this.frm.get('password').value;
//     }

//     @Output() onChanged = new EventEmitter<number>(); // выбран
//     @Output() onError = new EventEmitter<string>(); // Ошибка
//     @Output() onSuccess = new EventEmitter<string>();

//     constructor(
//         private auth: AuthService,
//         private router: Router,
//         private title: Title,
//         private configS: ConfigService,
//         private load: LoadService,
//         private activateRoute: ActivatedRoute,
//         private esia: EsiaService,
//         private cookieService: CookieConsentService,
//         private alertService: AlertService,
//     ) {
//         this.tmpToken = null;
//         this.tokens = null;

//         this.authSettings =
//             load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN;

//         const tmpTitle = this.authSettings?.TITLE;
//         if (tmpTitle) this.title.setTitle(tmpTitle);

//         this.dogPREVIEW_REQUIRED = this.authSettings
//             ?.IS_REQUIRED_CONTRACT_PREVIEW
//             ? true
//             : false;

//         this.getRolesConfig = !!this.authSettings?.IS_ROLES_SYSTEM;

//         this.Auth_type = this.authSettings?.AUTH_TYPE ?? 'base';

//         this.isRecovery = !!this.authSettings?.IS_RECOVERY_ENABLED;

//         // Проверка на возможность входа через ГосУслуги.
//         lastValueFrom(this.esia.getInfo$())
//             .then((result: string) => {
//                 if (result) {
//                     this.esia_link = result;
//                 }
//             })
//             .catch((error: any) => {
//                 return null;
//             });
//     }

//     ngOnInit(): void {
//         const tokenFromStorage = sessionStorage.getItem(
//             'sessionTokenAuthAriadna',
//         );

//         if (!tokenFromStorage) {
//             const token = Array(32)
//                 .fill('')
//                 .map(() =>
//                     String.fromCharCode(
//                         48 + Math.floor(Math.random() * (10 + 26 + 26)) - 10,
//                     ),
//                 )
//                 .join('');
//             sessionStorage.setItem('sessionTokenAuthAriadna', token);
//         }
//         // Проверка на state, переход с Госуслуг
//         if (
//             this.activateRoute.snapshot.queryParams &&
//             this.activateRoute.snapshot.queryParams.state
//         ) {
//             this.esia_state = this.activateRoute.snapshot.queryParams.state;
//             this.loading = true;
//             this.esia.getInfoState$(this.esia_state!).subscribe(
//                 (res: any) => {
//                     this.loading = false;
//                     this.tokens = res.token;
//                     this.tmpToken = {
//                         token: res.token,
//                         patientId: res.patientId,
//                     };
//                     this.cookieService.acceptAllCookies();
//                     this.setCookies(res.token);
//                     this.showDoglist = true;
//                 },
//                 (err: unknown) => {
//                     const message = Utils.getErrorMessage(err);
//                     this.alertService.error(message);
//                     this.onError.emit(message);
//                     this.loading = false;
//                 },
//             );
//         } else {
//             if (
//                 this.activateRoute.snapshot.queryParams &&
//                 this.activateRoute.snapshot.queryParams.ERR
//             ) {
//                 this.onError.emit('Ошибка получения данных от ГосУслуг.');
//             }
//             this.esia_state = null;
//             this.loading = false;
//         }

//         if (this.Auth_type === 'sms') {
//             // Только по телефону
//             this.goReg(3);
//             this.initialize();
//         } else {
//             this.initialize();
//         }
//     }

//     protected redirectTo(uri: string) {
//         this.router.navigate([uri]);
//     }

//     private async setAuthConfig(): Promise<void> {
//         if (this.getRolesConfig && this.tmpToken?.patientId) {
//             const res = await this.auth.getAccessConfig(
//                 this.tmpToken.patientId,
//             );
//             if (res.length <= 0) {
//                 res.push(
//                     'lk_access_appointment',
//                     'lk_access_patient_data',
//                     'lk_access_see_services',
//                 );
//             }
//             this.load.setAccessUserConfig(res);
//             // Надо будет доработать для обновления страницы юзера в случае несовпадений конфигов(Платная недоработка).
//             // setInterval(() => {
//             //     this.setAuthConfig();
//             //     if (res !== this.load.getAccessUserConfig) {
//             //         window.location.reload();
//             //     }
//             // }, 60 * 1000 * 60 * 1);
//         }
//     }
//     private initialize(): void {
//         this.frm = new FormGroup({
//             username: new FormControl('', [
//                 Validators.required,
//                 Validators.minLength(3),
//             ]),
//             password: new FormControl('', [
//                 Validators.required,
//                 Validators.minLength(3),
//             ]),
//         });
//     }

//     public loginOK(): void {
//         this.auth.loginOk$(this.tmpToken!.token, this.tmpToken!.patientId);
//         this.redirectTo('/home');
//     }

//     public onErrorDog(ev: string = ''): void {
//         this.onError.emit(ev);
//     }

//     public onEventDog(ev: string = ''): void {
//         //
//         switch (ev) {
//             case 'LOGINOK': {
//                 this.loginOK();
//                 break;
//             }
//             case 'LOGOUT': {
//                 this.logout();
//                 break;
//             }
//         }
//     }

//     /* Назад */
//     logout(): void {
//         this.auth.logout();
//         this.showDoglist = false;
//     }
//     private setCookies(token: string): void {
//         if (!document.cookie.includes('cookieconsent_status')) {
//             this.cookieService.setCookie('cookieconsent_status', 'true');
//         }
//         this.cookieService.setCookie('pa-web_Patient_Local', token);
//     }

//     async login(): Promise<void> {
//         this.loading = true;
//         this.tmpToken = null;
//         this.onError.emit('');
//         this.onSuccess.emit('');

//         try {
//             this.cookieService.acceptAllCookies();
//             const result = await this.auth.login$(this.username, this.password);
//             // this.setCookies(result.token!);

//             if (result.token && result.patientId) {
//                 this.tokens = result.token;
//                 this.tmpToken = {
//                     token: result.token,
//                     patientId: result.patientId,
//                 };
//                 await this.setAuthConfig();

//                 this.showDoglist = true;
//             }
//             // this.redirectTo('/home');
//         } catch (error: unknown) {
//             this.onError.emit(
//                 Utils.getErrorMessage(error, 'Неверный логин или пароль'),
//             );
//         } finally {
//             this.loading = false;
//         }
//     }

//     public trimInputsAndLogin(): void {
//         const usernameControl = this.frm.get('username');
//         const passwordControl = this.frm.get('password');

//         if (usernameControl && passwordControl) {
//             // удаляем пробелы
//             const trimmedUsername = usernameControl.value.trim();
//             const trimmedPassword = passwordControl.value.trim();

//             usernameControl.setValue(trimmedUsername);
//             passwordControl.setValue(trimmedPassword);

//             this.login();
//         } else {
//             this.login();
//         }
//     }

//     loginEsia(): void {
//         this.loading = true;
//         if (this.esia_link) {
//             window.location.href = this.esia_link;
//         }
//     }

//     whenAnimate(event: any) {
//         //
//         if (event.toState === 'off') {
//             //
//             this.onChanged.emit(this.paramEmit);
//         }
//     }

//     goReg(pVal: number): void {
//         this.paramEmit = pVal;
//         this.animState = 'off';
//     }

//     // Обновление картинки КАПЧИ
//     // public refreshCaptcha() {
//     //     this.captchaJpg =
//     //         this.configS.getValue('hostBackend') +
//     //         '/api/captcha.jpg?' +
//     //         new Date().getTime();
//     //     // @ts-ignore
//     //     if (this.frmReg && this.frmReg.controls) {
//     //         // @ts-ignore
//     //         this.frmReg.controls['captcha'].reset('');
//     //     }
//     // }
// }
